import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Mailto from 'react-mailto';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class AboutUs extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
    document.title = 'Diamonds Direct | Our Story';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	userNav(page) {
    // this.context.router.push('/' + page);
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  storeNav(page) {
    // this.context.router.push('/' + page);
    window.location.href = '/' + page;
  }

  jaxNav() {
  	let win = window.open('http://globaldiamondsusa.com/', '_blank');
    win.focus();
  }

	render() {
		return <div className='AboutUs'>

			<img src="https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=misc&pixid=4b33c0b1-6c94-4f15-9e92-13ad551a541e" width="1" height="1" />

			<div className={'aboutNumbers fullWidth'}>
				<img src='https://ddw2.diamondsdirect.com/img/aboutus/outlined/numbersanddiamonds.svg' />
			</div>
			<div className={'aboutConception partialWidth'}>
				<img src='https://ddw2.diamondsdirect.com/img/aboutus/outlined/concept.svg' />
			</div>
			<div className={'aboutYears partialWidth'}>
				<img src='https://ddw2.diamondsdirect.com/img/aboutus/outlined/60years.svg' />
				<div className={'heritageButton aboutButton'} onClick={() => this.userNav('our-heritage')}><div className={'aboutButtonText'}>Our Heritage</div></div>
			</div>
			<div className={'aboutChoic partialWidth'}>
				<img src='https://ddw2.diamondsdirect.com/img/aboutus/outlined/choice.svg' />
			</div>
			<div className={'aboutConfidenceTitle partialWidth'}>
				<img src='https://ddw2.diamondsdirect.com/img/aboutus/outlined/confidence_title.svg' />
			</div>
			<div className={'aboutConfidence partialWidth'}>
				<img src='https://ddw2.diamondsdirect.com/img/aboutus/outlined/confidence.svg' />
				<div className={'guaranteeButton aboutButton'} onClick={() => this.userNav('our-guarantees')}><div className={'aboutButtonText'}>Learn More</div></div>
			</div>
			<div className={'aboutCommunity fullWidth'}>
				<img src='https://ddw2.diamondsdirect.com/img/aboutus/community25.svg' />
				<div className='mapOverlay'>
					<div id="marker-austin" className="map-location-wrapper" onClick={() => this.storeNav('austin')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Austin,&nbsp;TX</div>
							<div className="store-link">Visit Store Page</div>
						</div>
					</div>
					<div id="marker-birmingham" className="map-location-wrapper" onClick={() => this.storeNav('birmingham')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Birmingham,&nbsp;AL</div>
							<div className="store-link">Visit Store Page</div>
						</div>
					</div>
					<div id="marker-charleston" className="map-location-wrapper" onClick={() => this.storeNav('charleston')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Charleston,&nbsp;SC</div>
							<div className="store-link">Visit Store Page</div>
						</div>
					</div>
					<div id="marker-clt" className="map-location-wrapper double-wrapper">
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Charlotte,&nbsp;NC</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-columbus" className="map-location-wrapper" onClick={() => this.storeNav('columbus')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Columbus, OH</div>
							<div className="store-link">Visit Store Page</div>
						</div>
					</div>
					<div id="marker-dallas" className={"map-location-wrapper double-wrapper"}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div onClick={() => this.storeNav('dallas')}>
								<div className="store-name">Dallas,&nbsp;TX</div>
								<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
							</div>
							<div className="horizontal-rule"></div>
							<div onClick={() => this.storeNav('frisco')}>
								<div className="store-name">Frisco,&nbsp;TX</div>
								<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
							</div>
						</div>
					</div>
					<div id="marker-indy" className="map-location-wrapper" onClick={() => this.storeNav('indianapolis')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Indianapolis, IN</div>
							<div className="store-link">Visit Store Page</div>
						</div>
					</div>
					<div id="marker-okc" className="map-location-wrapper" onClick={() => this.storeNav('oklahoma-city')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Oklahoma City, OK</div>
							<div className="store-link">Visit Store Page</div>
						</div>
					</div>
					<div id="marker-raleigh" className="map-location-wrapper" onClick={() => this.storeNav('raleigh')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Raleigh,&nbsp;NC</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-richmond" className="map-location-wrapper" onClick={() => this.storeNav('richmond')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Richmond,&nbsp;VA</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-stl" className="map-location-wrapper" onClick={() => this.storeNav('st-louis')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">St.&nbsp;Louis,&nbsp;MO</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-san" className="map-location-wrapper" onClick={() => this.storeNav('san-antonio')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">San&nbsp;Antonio,&nbsp;TX</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-vab" className="map-location-wrapper" onClick={() => this.storeNav('virginia-beach')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Virginia&nbsp;Beach,&nbsp;VA</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-globaldiamonds" className="map-location-wrapper" onClick={() => this.storeNav('jacksonville')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Jacksonville,&nbsp;FL</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-kcy" className="map-location-wrapper" onClick={() => this.storeNav('kansas-city')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Kansas&nbsp;City,&nbsp;KS</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-cle" className="map-location-wrapper" onClick={() => this.storeNav('cleveland')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Cleveland,&nbsp;OH</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-nol" className="map-location-wrapper" onClick={() => this.storeNav('new-orleans')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">New&nbsp;Orleans,&nbsp;LA</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-boc" className="map-location-wrapper" onClick={() => this.storeNav('boca-raton')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Boca&nbsp;Raton,&nbsp;FL</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>

					<div id="marker-try" className="map-location-wrapper" onClick={() => this.storeNav('troy')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Troy,&nbsp;MI</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>

					<div id="marker-hou" className={"map-location-wrapper double-wrapper"}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div onClick={() => this.storeNav('baybrook')}>
								<div className="store-name">Houston,&nbsp;TX&nbsp;(Baybrook)</div>
								<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
							</div>
							<div className="horizontal-rule"></div>
							<div onClick={() => this.storeNav('houston')}>
								<div className="store-name">Houston,&nbsp;TX&nbsp;(Galleria)</div>
								<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
							</div>
						</div>
					</div>
					<div id="marker-pit" className="map-location-wrapper" onClick={() => this.storeNav('pittsburgh')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Pittsburgh,&nbsp;PA</div>
							<div className="store-link">Visit&nbsp;Store&nbsp;Page</div>
						</div>
					</div>
					<div id="marker-gsc" className="map-location-wrapper" onClick={() => this.storeNav('greenville')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Greenville,&nbsp;SC</div>
							<div className="store-link">Visit Store Page</div>
						</div>
					</div>
					<div id="marker-cle" className="map-location-wrapper" onClick={() => this.storeNav('cleveland')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Cleveland,&nbsp;OH</div>
							<div className="store-link">Visit Store Page</div>
						</div>
					</div>
					<div id="marker-nva" className="map-location-wrapper" onClick={() => this.storeNav('tysons')}>
						<div className="marker-wrapper">
							<div className="store-marker">&nbsp;</div>
						</div>
						<div className="store-label">
							<div className="store-name">Tysons,&nbsp;VA</div>
							<div className="store-link">Visit Store Page</div>
						</div>
					</div>
				</div>
				<div className={'locateStoreButton aboutButton'} onClick={() => this.userNav('locations')}>
					<div className={'aboutButtonText'}>Visit Us</div>
				</div>
				<div className={'joinTeamButton aboutButton'} onClick={() => this.internalNav('careers')}>
					<div className={'aboutButtonText'}>Join Our Team</div>
				</div>
			</div>
			<div className={'aboutSocial partialWidth'}>
				<div className={'socialWrapper desktopOnly'}>
					<div className='socialLHS'>
						<img src='https://ddw2.diamondsdirect.com/img/aboutus/social/socialL.jpg' />
					</div>
					<div className='socialRHS'>
						<div className='rhsWrapper'><img src='https://ddw2.diamondsdirect.com/img/aboutus/social/social1.jpg' /></div>
						<div className='rhsWrapper'><img src='https://ddw2.diamondsdirect.com/img/aboutus/social/social2.jpg' /></div>
						<div className='rhsWrapper'><img src='https://ddw2.diamondsdirect.com/img/aboutus/social/social3.jpg' /></div>
						<div className='rhsWrapper'><img src='https://ddw2.diamondsdirect.com/img/aboutus/social/social4.jpg' /></div>
					</div>
				</div>
				<div className={'mobileSocialWrapper mobileOnly'}>
					<div className='mobSocialImg'><img src='https://ddw2.diamondsdirect.com/img/aboutus/social/socialL.jpg' /></div>
					<div className='mobSocialImg'><img src='https://ddw2.diamondsdirect.com/img/aboutus/social/social1.jpg' /></div>
					<div className='mobSocialImg'><img src='https://ddw2.diamondsdirect.com/img/aboutus/social/social2.jpg' /></div>
					<div className='mobSocialImg'><img src='https://ddw2.diamondsdirect.com/img/aboutus/social/social3.jpg' /></div>
					<div className='mobSocialImg'><img src='https://ddw2.diamondsdirect.com/img/aboutus/social/social4.jpg' /></div>
				</div>
				<div className={'visitUsButton aboutButton'} onClick={() => this.userNav('locations')}><div className={'aboutButtonText'}>Visit Us</div></div>
			</div>
			<div className={'aboutDonated fullWidth'}>
				<img src='https://ddw2.diamondsdirect.com/img/aboutus/outlined/community_donations.svg' />
				<div className={'foundationButton aboutButton'} onClick={() => this.userNav('our-foundation')}><div className={'aboutButtonText'}>Learn More</div></div>
			</div>
		</div>;
	}
}
export default AboutUs;

function mapStateToProps(state) {
  return {

  };
}

export const AboutUsContainer = connect(
  mapStateToProps,
  allActionCreators
)(AboutUs);


// WEBPACK FOOTER //
// ./src/components/views/aboutus/AboutUs.jsx